
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Pie, mixins } from 'vue-chartjs';
import { generatePie, PieConfig } from './pie';
import {
  _isEmpty,
} from '@samclick-lodash';

enum PieChartType {
    PIE = 'PIE',
}

    @Component({
      extends: Pie,
      mixins: [mixins.reactiveProp],
      props: {
        title: {
          type: String,
          default: '',
        },
        type: {
          type: String,
          required: true,
        },
        config: {
          type: Object,
          required: true,
        },
        data: {
          type: Array,
          required: true,
        },
        chartData: {
          type: Object,
          default: () => ({}),
        },
      },
    })
class PieChart extends Vue<Pie> {
        @Watch('$props.data', { immediate: true })
      dataWatcher(newVal: string, oldVal: string) {
        if (!_isEmpty(newVal)) {
          this.renderPieChart();
        } else if (_isEmpty(newVal) && this._data && this._data._chart) {
          this._data._chart.destroy();
        }
      }

        renderPieChart() {
          const self = this;
          let chartDetail = { labels: [], datasets: [] };
          if (this.$props.type === PieChartType.PIE) {
            chartDetail = generatePie(this.$props.config, this.$props.data, this.$props);
          }

          this.$nextTick(() => {
            self.renderChart(chartDetail.chartData, chartDetail.chartOptions);
          });
        }

        mounted() {
          this.renderPieChart();
        }
    }

export { PieChartType, PieConfig };
export default PieChart;
